export default __webpack_public_path__ + "static/media/Snd_TryT.076fd98b.mp3";